import PropTypes from 'prop-types';
import { Component } from 'react';
import { List } from 'immutable';
import { connect } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Banner } from 'foundations-components/transitional/components/Banner';
import LoadingWrapper from './LoadingWrapper';
import { loadAttributes } from '../actions/AttributeActions';
import { loadHubUsers } from '../actions/HubUsersActions';
import { loadProfile, loadProfileHubless, loadIsScimUser } from '../actions/ProfileActions';
import { loadIsRestrictedImpersonatee } from '../actions/IsRestrictedImpersonateeActions';
import { loadProfileOptions, loadProfileOptionsHubless } from '../actions/ProfileOptionsActions';
import BlankNameModalContainer from '../containers/BlankNameModalContainer';
import UnrecoverableError from '../components/UnrecoverableError';
import { isApplicationHubless, isUserImpersonated as getIsUserImpersonated } from '../selectors/AuthSelector';
import { getUnrecoverableErrors } from '../selectors/ErrorSelector';
import { getFirstNameFromCurrentUserProfile, getLastNameFromCurrentUserProfile } from '../selectors/ProfileSelector';
import { getFetchProfileRequestStatus, getFetchIsScimUserRequestStatus, getFetchProfileOptionsRequestStatus, getFetchNotificationsRequestStatus, getFetchHubUsersRequestStatus, getFetchIsRestrictedImpersonateesRequestStatus } from '../selectors/RequestStatusSelector';
import { anyRequestsFailed } from '../utils/requestUtils';
import RequestStatusTypes from '../constants/RequestStatusTypes';
import ErrorBoundary from 'UserPreferencesUI/components/ErrorBoundary';
import { NavMarker } from 'react-rhumb';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const loadOnce = (loader, requestStatus) => {
  if (!requestStatus || requestStatus === RequestStatusTypes.UNINITIALIZED) {
    loader();
  }
};
const UserApiFailureBanner = () => /*#__PURE__*/_jsx(Banner, {
  titleText: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "failures.userApiFailure.title"
  }),
  marginBlockEnd: "800",
  children: /*#__PURE__*/_jsx("p", {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "failures.userApiFailure.description"
    })
  })
});
class UserPreferencesPage extends Component {
  componentDidMount() {
    const {
      fetchIsRestrictedImpersonateesRequestStatus,
      fetchProfileRequestStatus,
      fetchIsScimUserRequestStatus,
      fetchProfileOptionsRequestStatus,
      fetchHubUsersRequestStatus,
      isUserImpersonated,
      isHubless
    } = this.props;
    if (isHubless) {
      loadOnce(this.props.loadProfileHubless, fetchProfileRequestStatus);
      loadOnce(this.props.loadProfileOptionsHubless, fetchProfileOptionsRequestStatus);
    } else {
      loadOnce(this.props.loadProfile, fetchProfileRequestStatus);
      loadOnce(this.props.loadProfileOptions, fetchProfileOptionsRequestStatus);
      loadOnce(this.props.loadHubUsers, fetchHubUsersRequestStatus);
      // TODO: We should add an API way to fetch for hubless as well
      loadOnce(this.props.loadIsScimUser, fetchIsScimUserRequestStatus);
      if (isUserImpersonated) {
        loadOnce(this.props.loadIsRestrictedImpersonatee, fetchIsRestrictedImpersonateesRequestStatus);
      }
    }
  }
  getBlockingRequestStatuses() {
    const {
      fetchProfileRequestStatus
    } = this.props;
    return [fetchProfileRequestStatus];
  }
  getErrorCheckRequestStatuses() {
    const {
      fetchProfileRequestStatus,
      fetchNotificationsRequestStatus
    } = this.props;
    return [fetchProfileRequestStatus, fetchNotificationsRequestStatus];
  }
  renderContent() {
    const {
      children,
      hasName,
      unrecoverableErrors,
      loadWithErrors,
      isUserImpersonated
    } = this.props;
    const showErrorState = unrecoverableErrors.size || anyRequestsFailed.apply(null, this.getErrorCheckRequestStatuses());
    if (showErrorState) {
      // ** Edge case **
      //  `loadWithErrors` allows page to load even though part of the payload is failing
      // Currently only used in `SecurityContainer`
      if (loadWithErrors) {
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(UserApiFailureBanner, {}), children]
        });
      }
      // @ts-expect-error ts-migrate(2322) FIXME: Type '{ errors: any; }' is not assignable to type ... Remove this comment to see the full error message
      return /*#__PURE__*/_jsx(UnrecoverableError, {
        errors: unrecoverableErrors
      });
    }
    if (!hasName && !isUserImpersonated) {
      return /*#__PURE__*/_jsx(BlankNameModalContainer, {});
    }
    return children;
  }
  render() {
    return /*#__PURE__*/_jsx(ErrorBoundary, {
      children: /*#__PURE__*/_jsx(LoadingWrapper, {
        requestStatuses: this.getBlockingRequestStatuses(),
        children: /*#__PURE__*/_jsx(NavMarker, {
          name: "UP_FRONT_REQUEST_LOADED",
          children: this.renderContent()
        })
      })
    });
  }
}
UserPreferencesPage.defaultProps = {
  loadWithErrors: false
};
UserPreferencesPage.propTypes = {
  children: PropTypes.node.isRequired,
  fetchIsRestrictedImpersonateesRequestStatus: PropTypes.string.isRequired,
  fetchHubUsersRequestStatus: PropTypes.string.isRequired,
  fetchNotificationsRequestStatus: PropTypes.string.isRequired,
  fetchProfileOptionsRequestStatus: PropTypes.string.isRequired,
  fetchProfileRequestStatus: PropTypes.string.isRequired,
  fetchIsScimUserRequestStatus: PropTypes.string.isRequired,
  hasName: PropTypes.bool,
  isHubless: PropTypes.bool.isRequired,
  loadIsRestrictedImpersonatee: PropTypes.func.isRequired,
  loadHubUsers: PropTypes.func.isRequired,
  loadProfile: PropTypes.func.isRequired,
  loadProfileHubless: PropTypes.func.isRequired,
  loadIsScimUser: PropTypes.func.isRequired,
  loadProfileOptions: PropTypes.func.isRequired,
  loadProfileOptionsHubless: PropTypes.func.isRequired,
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'typeof List' is not assignable t... Remove this comment to see the full error message
  unrecoverableErrors: PropTypes.instanceOf(List),
  loadWithErrors: PropTypes.bool,
  isUserImpersonated: PropTypes.bool.isRequired
};
const mapStateToProps = (state, {
  params
}) => {
  return {
    // @ts-expect-error ts-migrate(2554) FIXME: Expected 1 arguments, but got 2.
    fetchHubUsersRequestStatus: getFetchHubUsersRequestStatus(state, {
      params
    }),
    // @ts-expect-error ts-migrate(2554) FIXME: Expected 1 arguments, but got 2.
    fetchNotificationsRequestStatus: getFetchNotificationsRequestStatus(state, {
      params
    }),
    // @ts-expect-error ts-migrate(2554) FIXME: Expected 1 arguments, but got 2.
    fetchProfileRequestStatus: getFetchProfileRequestStatus(state, {
      params
    }),
    // @ts-expect-error ts-migrate(2554) FIXME: Expected 1 arguments, but got 2.
    fetchIsScimUserRequestStatus: getFetchIsScimUserRequestStatus(state, {
      params
    }),
    fetchProfileOptionsRequestStatus: getFetchProfileOptionsRequestStatus(state,
    // @ts-expect-error ts-migrate(2554) FIXME: Expected 1 arguments, but got 2.
    {
      params
    }),
    fetchIsRestrictedImpersonateesRequestStatus: getFetchIsRestrictedImpersonateesRequestStatus(state),
    hasName: getFirstNameFromCurrentUserProfile(state) !== null && getLastNameFromCurrentUserProfile(state) !== null,
    isHubless: isApplicationHubless(state),
    unrecoverableErrors: getUnrecoverableErrors(state),
    isUserImpersonated: getIsUserImpersonated(state)
  };
};
export default connect(mapStateToProps, {
  loadIsRestrictedImpersonatee,
  loadProfile,
  loadProfileHubless,
  loadIsScimUser,
  loadProfileOptions,
  loadProfileOptionsHubless,
  loadAttributes,
  loadHubUsers
})(UserPreferencesPage);